import network from "@/domain/boilerRoom/network";
import mintToken from "@/domain/boilerRoom/mintToken";

const store = {
  namespaced: true,
  state: {
    data: {
      NETWORK: network.name,
      CHAIN_ID: network.chainIds[0],
      coinSymbol: mintToken.name,
      mainCoinImage: null,
      smallerCoinImage: null,
      stakeTokenAddress: mintToken.contractAddress,
      stakeTokenSymbol: mintToken.name,
      stakeTokenDecimals: mintToken.decimals,
      rewardTokenAddress: mintToken.contractAddress,
      rewardTokenSymbol: mintToken.name,
      rewardTokenDecimals: mintToken.decimals,
      isMintable: true,
      isRedeemable: true,
      totalSupply: `${0}`,
      maxSupply: `${0}`,
      allFees: {
        mFee: 0,
        mFeeDenominator: 0,
        rFee: 0,
        rFeeDenominator: 0,
      },
      mintingPerLimit: `${0}`,
      stakedPeggedToken: `${0}`,
      stakedPeggedTokenOne: `${0}`,
      status: "ACTIVE",
      isMaster: false,
      isFrozen: false,
      isFinished: false,
      account: {
        busdBalance: `${0}`,
        balance: `${0}`,
        saunaBalance: `${0}`,
        claimableMintsBalance: `${0}`,
        claimableRedemptionsBalance: {
          busdBalance: `${0}`,
          saunaBalance: `${0}`,
        },
        isApproved: false,
      },
      createdAt: new Date().getTime(),
      updatedAt: new Date().getTime(),
    },
  },
  getters: {},
  mutations: {
    update(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    update({ commit }, payload) {
      commit("update", payload);
    },
  },
};

export default store;
